/**
 * Who wrote it and which build is running.
 *
 * `__APP_VERSION__` is replaced at build time from apps/web/package.json (see
 * the `define` in vite.config.ts and its twin in vitest.config.ts), so the
 * version is bumped in exactly one place — and it must be bumped on every
 * deploy, or the About row starts lying about what a phone is holding.
 */

declare const __APP_VERSION__: string

export const APP_VERSION: string = __APP_VERSION__

export const COPYRIGHT_HOLDER = 'Saulius Muzikevičius'

/** „© 2026 Saulius Muzikevičius" — the year moves on its own. */
export function copyrightLine(now: Date = new Date()): string {
  return `© ${now.getFullYear()} ${COPYRIGHT_HOLDER}`
}
